exports = module.exports = require("../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".message[data-v-5b589c87]{padding:0 20px}", ""]);

// exports
